module.exports = __webpack_public_path__ + "static/gallery_peak_4-3360fd828eed1ca14d7b75ceccca1394.jpg";